import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, Phone, Mail, ShieldCheck } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export default function StorefrontFooter() {
    const { settings } = useSettings();
    return (
        <footer className="border-t border-[#27272A] bg-[#09090B] mt-16">
            <div className="container mx-auto px-4 py-12 grid grid-cols-2 md:grid-cols-4 gap-8">
                <div className="col-span-2 md:col-span-1">
                    <Link to="/" data-testid="footer-logo">
                        <img
                            src={settings?.logo_url}
                            alt={settings?.store_name || "Opensea"}
                            className="h-16 md:h-20 w-auto max-h-20 object-contain mb-4"
                        />
                    </Link>
                    <p className="text-white/60 text-sm leading-relaxed">
                        {settings?.tagline ||
                            "Premium fishing gear, built for the pursuit. Rods, reels, lures and more — handpicked for serious anglers."}
                    </p>
                    <div className="flex items-center gap-3 mt-5">
                        {settings?.instagram_url && (
                            <a
                                href={settings.instagram_url}
                                target="_blank"
                                rel="noreferrer"
                                className="p-2 border border-[#27272A] rounded-sm text-white hover:text-[#00BCE5] hover:border-[#00BCE5]"
                                aria-label="Instagram"
                                data-testid="footer-instagram-link"
                            >
                                <Instagram size={16} />
                            </a>
                        )}
                        {settings?.facebook_url && (
                            <a
                                href={settings.facebook_url}
                                target="_blank"
                                rel="noreferrer"
                                className="p-2 border border-[#27272A] rounded-sm text-white hover:text-[#00BCE5] hover:border-[#00BCE5]"
                                aria-label="Facebook"
                            >
                                <Facebook size={16} />
                            </a>
                        )}
                        {settings?.youtube_url && (
                            <a
                                href={settings.youtube_url}
                                target="_blank"
                                rel="noreferrer"
                                className="p-2 border border-[#27272A] rounded-sm text-white hover:text-[#00BCE5] hover:border-[#00BCE5]"
                                aria-label="YouTube"
                            >
                                <Youtube size={16} />
                            </a>
                        )}
                    </div>
                </div>

                <div>
                    <h4 className="font-display uppercase tracking-widest text-sm text-white mb-3">Shop</h4>
                    <ul className="space-y-2 text-sm text-white/60">
                        <li><Link to="/shop" className="hover:text-[#00BCE5]" data-testid="footer-shop-all">All Products</Link></li>
                        <li><Link to="/shop?new=1" className="hover:text-[#00BCE5]">New Arrivals</Link></li>
                        <li><Link to="/shop?sale=1" className="hover:text-[#00BCE5]">Sale</Link></li>
                        <li><Link to="/shop?featured=1" className="hover:text-[#00BCE5]">Best Sellers</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-display uppercase tracking-widest text-sm text-white mb-3">Help</h4>
                    <ul className="space-y-2 text-sm text-white/60">
                        <li><Link to="/track-order" className="hover:text-[#00BCE5]">Track Order</Link></li>
                        <li><Link to="/contact" className="hover:text-[#00BCE5]">Contact</Link></li>
                        <li><Link to="/policy/terms" className="hover:text-[#00BCE5]">Terms &amp; Conditions</Link></li>
                        <li><Link to="/policy/payments" className="hover:text-[#00BCE5]">Payment Terms</Link></li>
                        <li><Link to="/policy/shipping" className="hover:text-[#00BCE5]">Shipping Policy</Link></li>
                        <li><Link to="/policy/returns" className="hover:text-[#00BCE5]">Return &amp; Cancellation Policy</Link></li>
                        <li><Link to="/policy/privacy" className="hover:text-[#00BCE5]">Privacy Policy</Link></li>
                    </ul>
                </div>

                <div>
                    <h4 className="font-display uppercase tracking-widest text-sm text-white mb-3">Get in touch</h4>
                    <ul className="space-y-2 text-sm text-white/60">
                        {settings?.contact_phone && (
                            <li className="flex items-center gap-2"><Phone size={14} /> {settings.contact_phone}</li>
                        )}
                        {settings?.contact_email && (
                            <li className="flex items-center gap-2"><Mail size={14} /> {settings.contact_email}</li>
                        )}
                        <li className="flex items-center gap-2 text-[#00BCE5]"><ShieldCheck size={14} /> 100% Authentic Tackle</li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-[#27272A] py-5 text-center text-xs text-white/45 font-display uppercase tracking-widest">
                © {new Date().getFullYear()} {settings?.store_name || "Opensea Fishing Tackles"}. All rights reserved.
            </div>
        </footer>
    );
}
